
/* injects from baggage-loader */

'use strict';

import config from './index.config';
import run from './index.run';

import uiRouter from '@uirouter/angularjs';

import coreModule from './core/core.module';
import indexComponents from './index.components';
import indexRoutes from './index.routes';

// Import ui bootstrap modules
import alert from 'ui-bootstrap4/src/alert';
import modal from 'ui-bootstrap4/src/modal';
import accordian from 'ui-bootstrap4/src/accordion';

// Import pages
import homeModule from './pages/home/home.module';
import loginModule from './pages/login/login.module';
import signupModule from './pages/signup/signup.module';
import recoverPassword from './pages/recoverPassword/recoverpassword.module';
import passwordReset from './pages/passwordReset/passwordreset.module';
import learnModule from './pages/learn/learn.module';
import raiseFundsModule from './pages/raise-funds/raise-funds.module';
import projectsModule from './pages/projects/projects.module';
import projectModule from './pages/project/project.module';
// import projectInvestModule from './pages/project-invest/project.invest.module';
import projectInvestmentWizardPageModule from './pages/projectInvestmentWizard/projectinvestmentwizard.module';
import accountModule from './pages/account/account.module';
import accountLogoutModule from './pages/account-logout/account-logout.module';
import manageProjectModule from './pages/manageProject/manageproject.module';

const App = angular.module("historicFunds",
	[
		// plugins
		uiRouter,
		"ngAnimate",
		"ngCookies",
		"ngTouch",
		"ngSanitize",
		"ngMessages",
		"ngAria",
		"ngResource",
		"oc.lazyLoad",
		
		"angular-loading-bar",
		"ngAvatar",
		"yaru22.angular-timeago",
		"angular-stripe",
		"textAngular",
		"duScroll",
		"ngFileUpload",
		"dndLists",

		// UI Bootstrap modules
		alert,
		modal,
		accordian,

		// core
		coreModule.name,

		// components
		indexComponents.name,

		// routes
		indexRoutes.name,

		// pages
		homeModule.name,
		loginModule.name,
		signupModule.name,
		recoverPassword.name,
		passwordReset.name,
		learnModule.name,
		raiseFundsModule.name,
		projectsModule.name,
		projectModule.name,
		projectInvestmentWizardPageModule.name,
		manageProjectModule.name,

		// page - User account
		accountModule.name,
		accountLogoutModule.name,

	]
);

App
	.config(config)
	.run(run);

export default App;


// WEBPACK FOOTER //
// ./src/app/index.module.js